function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function matchComponent(component) {
  var match = component.match(/([\[|{])([0-9]+)[\]|}]/); // eslint-disable-line no-useless-escape
  if (!match) {
    return {
      component: component,
      arrayAccessor: false,
      accessById: false
    };
  }
  if (match[1] === '[') {
    return {
      component: Number(match[2]),
      arrayAccessor: true,
      accessById: false
    };
  }
  return {
    component: Number(match[2]),
    arrayAccessor: true,
    accessById: true
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/ban-types
function applyPath(input, path, value) {
  var fullPath = path.split('.');
  var temp = input;
  var _loop = function _loop() {
    var _matchComponent2 = matchComponent(fullPath[i]),
      component = _matchComponent2.component,
      accessById = _matchComponent2.accessById;
    var _matchComponent3 = matchComponent(fullPath[i + 1]),
      nextArrayAccessor = _matchComponent3.arrayAccessor;

    // if the next component is supposed to be an array, make sure it's set
    if (nextArrayAccessor) {
      temp[component] = temp[component] || [];
    } else if (!accessById) {
      temp[component] = temp[component] || {};
    }
    if (Array.isArray(temp)) {
      if (accessById) {
        var found = temp.find(function (item) {
          return item.id === component;
        });
        if (found) {
          temp = found;
        } else {
          var item = {
            id: component
          };
          temp.push(item);
          temp = item;
        }
      } else {
        temp = temp[component];
      }
    } else {
      temp = temp[component];
    }
  };
  for (var i = 0; i < fullPath.length - 1; i++) {
    _loop();
  }
  var _matchComponent = matchComponent(fullPath[fullPath.length - 1]),
    finalComponent = _matchComponent.component;
  temp[finalComponent] = value;
  return input;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var applyDiff = function applyDiff(obj, diff) {
  if (!diff || _typeof(diff) !== 'object' || Object.keys(diff).length <= 0) return obj;
  if (!obj || _typeof(obj) !== 'object') return obj;
  return Object.keys(diff).reduce(function (acc, key) {
    var value = diff[key];
    return applyPath(acc, key, value);
  }, obj);
};
export default applyDiff;